import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { themeCheck } from '@upr-gds-web/components';
import { sendEvent } from '@upr-web-primer/app-utils';
import { CALENDAR_TRIGGER_EVENT_KEYS, CALENDAR_OUTPUT_EVENT_KEYS } from '@upr-web-primer/gds-calendar';
import * as i4 from '@upr-web-primer/gds-common-utility';
import * as i11 from '@upr-web-primer/gds-comparison-table';
import * as i3 from '@upr-web-primer/gds-data-model';
import * as i10 from '@upr-web-primer/gds-input-form';
import { GdsInputFormComponent } from '@upr-web-primer/gds-input-form';
import * as i9 from '@upr-web-primer/gds-poi';
import * as i5 from '@upr-web-primer/gds-route-resolver';
import * as i2 from '@upr-web-primer/gds-text';
import * as i6 from '@upr-web-primer/gds-trip-advisor';
import * as i1 from '@upr-web-primer/gds-youtube';
import * as i7 from '@upr-web-primer/locale';
import * as i8 from '@upr-web-primer/page-labels';
import { WINDOW } from '@upr-web-primer/window';
import { get, set, isEmpty } from 'lodash-es';
import { Settings, DateTime } from 'luxon';
import moment from 'moment';
import { Subscription, fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';
class GdsModalModule {
  static {
    this.ɵfac = function GdsModalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsModalModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsModalModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsModalModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsModalService {
  constructor(document, appDefaults, window, gdsYouTubePlayer, gdsText, gdsModelService, utilities, routeResolver, tripAdvisor, localeService, pageLabelsResolver, gdsPoiService, gdsInputFormService, rendererFactory, gdsComparisonTableService) {
    this.document = document;
    this.appDefaults = appDefaults;
    this.window = window;
    this.gdsYouTubePlayer = gdsYouTubePlayer;
    this.gdsText = gdsText;
    this.gdsModelService = gdsModelService;
    this.utilities = utilities;
    this.routeResolver = routeResolver;
    this.tripAdvisor = tripAdvisor;
    this.localeService = localeService;
    this.pageLabelsResolver = pageLabelsResolver;
    this.gdsPoiService = gdsPoiService;
    this.gdsInputFormService = gdsInputFormService;
    this.rendererFactory = rendererFactory;
    this.gdsComparisonTableService = gdsComparisonTableService;
    this.slotAvailable = (selector, timeout = 300, attempts = 20) => {
      return new Promise(resolve => {
        let i = 0;
        const awaitElement = () => {
          const element = this.modalEl.querySelector(selector);
          if (element) {
            resolve(element);
          } else if (i > attempts) {
            resolve(null);
          } else {
            setTimeout(awaitElement, timeout);
          }
          i++;
        };
        awaitElement();
      });
    };
    // helpers
    this.isModalFullScreen = () => this.modalEl.tagName.toLowerCase() === 'gds-full-screen-modal';
    this.isAttrAvailable = (attribute, value) => this.modalEl.getAttribute(attribute) === value;
    this.renderer2 = this.rendererFactory.createRenderer(null, null);
    const locale = this.localeService.getFromStorage();
    this.language = this.document.documentElement.lang || locale.language;
    this.pageLabelsResolver.get().then(pageLabels => {
      this.pageLabels = pageLabels;
    });
    this.country = locale.country || get(this.appDefaults, 'DEFAULT_ROUTE_LANGUAGE');
    this.locale_id = [this.language, this.country.toUpperCase()].join('-');
    this.reviewList = [];
    const language = locale?.language || 'en';
    const country = this.country?.toUpperCase();
    this.dateFormatPerLocale = `${language}-${country}`;
    Settings.defaultZone = this.appDefaults.UPR_TIME_ZONE;
    this.subscriptions = new Subscription();
  }
  loadModal(button, content, isContrast, btnEvent, theme, useTridionData, viewContainerRef) {
    const yt = this.document.body.querySelector('gds-youtube-player');
    if (yt) {
      yt.pause();
    }
    this.rootViewContainerRef = viewContainerRef;
    const buttonId = get(btnEvent, 'detail.id');
    const modalAlreadyOpen = this.document.querySelector(`gds-modal[data-button-id="${buttonId}"]`);
    if (modalAlreadyOpen) return;
    this.useTridionData = useTridionData;
    this.btnTarget = get(button, 'target');
    this.isContrast = isContrast;
    this.theme = themeCheck(theme);
    this.modalEl = ['modal', 'youtube'].includes(this.btnTarget) ? this.document.createElement('gds-modal') : this.document.createElement('gds-full-screen-modal');
    this.modalEl.contrast = this.isContrast;
    this.modalEl.setAttribute('opened', true);
    this.modalEl.setAttribute('data-button-id', buttonId);
    this.modalEl.setAttribute('theme', this.theme);
    this.hasVideo = get(button, 'videoId') || get(button, 'modalContent.EmbeddedValues[0].component.LinkedComponentValues[0].Fields.button.EmbeddedValues[0].link.EmbeddedValues[0].External.Values[0]') || get(content, 'button.EmbeddedValues[0].videoId.Values[0]') || get(content, 'mediaButton.EmbeddedValues[0].videoId.Values[0]') || '';
    if (this.hasVideo) {
      this.modalEl.setAttribute('isyoutube', true);
    }
    this.backLabelText = get(content, 'button.EmbeddedValues[0].link.EmbeddedValues[0].Component.LinkedComponentValues[0].Fields.backLabelText.Values[0]') || get(this.pageLabels, 'GDSBackLabel');
    const analytics = get(content, 'mediaButton.EmbeddedValues[0].analytics.Values[0]') || get(content, 'button.EmbeddedValues[0].analytics.Values[0]') || get(button, 'analytics');
    if (!!analytics) {
      this.modalEl.analyticsTitle = analytics;
    }
    this.modalContent = get(button, 'modalContent.EmbeddedValues') || get(button, 'modalContent');
    if (!!this.modalContent) {
      this.detailBtnTarget = 'initial';
      this.transcludeGdsComponents(this.modalContent, this.isContrast, this.theme);
      return;
    }
    const headerTemplate = this.transcludeModalHeaderTemplate(content);
    const bodytemplate = this.transcludeModalBodyTemplate(button, content, this.isContrast);
    if (headerTemplate) {
      this.modalEl.setAttribute('header', true);
      this.appendWhenAvailable(headerTemplate, '.gds-modal-header');
    }
    if (bodytemplate) {
      this.appendWhenAvailable(bodytemplate, '.gds-modal-body');
    }
    this.renderModal();
  }
  async appendWhenAvailable(node, selector) {
    const elem = await this.slotAvailable(selector, 300, 10);
    if (elem) {
      elem.appendChild(node);
    }
  }
  buttonEventHandler(event) {
    const btnData = get(event, 'detail.data.button') || get(event, 'detail.data');
    if (!btnData) return;
    const btnType = get(btnData, 'type');
    if (btnType === 'right-arrow' || btnType === 'left-arrow' || btnType === 'close') {
      return;
    }
    this.detailBtnTarget = get(btnData, 'target');
    if (this.detailBtnTarget === 'application') {
      //Custom Event Detail from Tridion component
      const customEventDetailData = get(btnData, 'customEventDetail') || [];
      const customEventDetailObject = this.utilities.createObjectFromArray(customEventDetailData);
      this.utilities.applicationRequestHandler(customEventDetailObject);
      return;
    }
    this.modalContent = get(btnData, 'modalContent.EmbeddedValues');
    // detail view of modal on top of a full screen modal
    if (this.utilities.isModal(this.detailBtnTarget, btnType)) {
      if (this.isModalFullScreen() && this.isAttrAvailable('isdetail', 'false') && !!this.modalContent && !this.modalEl.querySelector('.insert-detail').childElementCount) {
        this.transcludeGdsComponents(this.modalContent, this.isContrast, this.theme);
      }
      this.setUpPage2();
      return;
    }
    // handle route links
    this.routeResolver.resolveRoute(btnData);
    // close modal if navigation happens via angular routing
    if (this.detailBtnTarget === 'routeLink' && btnData.href) this.modalEl.close();
  }
  transcludeGdsComponents(content, contrast, theme) {
    content.forEach(cp => {
      const gdsTemplateName = get(cp, 'componentTemplate.KeywordValues[0].MetadataFields.name.Values[0]') || get(cp, 'componentTemplate.Meta.name') || get(cp, 'componentTemplate.key');
      const componentAttribute = get(cp, 'componentTemplate.KeywordValues[0].MetadataFields.attributes.EmbeddedValues[0].value.Values[0]') || get(cp, 'componentTemplate.Meta.attributes[0].value');
      const componentContent = get(cp, 'component.LinkedComponentValues[0].Fields') || get(cp, 'component[0]');
      if (!gdsTemplateName || !componentContent) {
        return;
      }
      let gdsComponentContent = this.useTridionData ? this.gdsModelService.init(componentContent) : this.gdsModelService.parseContent(componentContent);
      const list = get(gdsComponentContent, 'items', '');
      if (list) set(gdsComponentContent, 'items', [].concat(list));
      const gdsComponent = this.document.createElement(gdsTemplateName);
      if (gdsTemplateName === 'gds-article-detail') {
        const venueId = get(cp, 'component.LinkedComponentValues[0].MetadataFields.venueId.Values[0]', '');
        this.gdsPoiService.getDiningHours(gdsComponent, venueId);
      }
      if (gdsTemplateName === 'gds-expanded-offer-detail') {
        set(gdsComponentContent, 'offer.currency', this.appDefaults.DEFAULT_CURRENCY_SYMBOL);
      }
      if (gdsTemplateName === 'gds-event-day-calendar') {
        this.setCalendarData(gdsComponentContent, gdsComponent);
      }
      if (gdsTemplateName === 'gds-callout-form-container') {
        this.setCalloutFormData({
          ...gdsComponent,
          data: gdsComponentContent
        }, componentContent.backgroundColor);
      }
      if (gdsTemplateName === 'gds-form-container') {
        if (componentContent.pageTemplate === 'gds input form page template') {
          this.renderInputForm({
            ...gdsComponent,
            data: gdsComponentContent
          });
          return;
        } else {
          const formContainerComponent = gdsComponent.cloneNode(true);
          const data = {
            ...gdsComponentContent
          };
          formContainerComponent.data = data;
          formContainerComponent.theme = theme;
          this.gdsInputFormService.getServiceDetails(data);
          gdsComponentContent = this.gdsInputFormService.setFormContainerData({
            ...gdsComponentContent
          });
          this.addFormToSlot(formContainerComponent);
        }
      }
      if (gdsTemplateName === 'gds-comparison-table') {
        gdsComponentContent = this.gdsComparisonTableService.parse(gdsComponentContent, gdsComponent);
      }
      if (componentAttribute) {
        gdsComponent.setAttribute(gdsTemplateName === 'gds-content-feature' ? 'image-position' : 'type', componentAttribute);
      }
      gdsComponent.setAttribute('data', JSON.stringify(gdsComponentContent));
      gdsComponent.setAttribute('contrast', contrast);
      gdsComponent.setAttribute('theme', theme);
      gdsComponent.setAttribute('inmodal', true);
      if (this.detailBtnTarget === 'initial') {
        if (this.btnTarget === 'modal') {
          this.appendWhenAvailable(gdsComponent, '.gds-modal-body');
        } else if (this.btnTarget === 'fullScreenModal') {
          this.modalEl.setAttribute('svgon', false);
          this.appendWhenAvailable(gdsComponent, '.insert-component');
        }
      } else if (this.isModalFullScreen() && ['modal', 'fullScreenModal'].includes(this.detailBtnTarget)) {
        this.setUpPage2();
        this.appendWhenAvailable(gdsComponent, '.insert-detail');
      }
      this.renderModal();
    });
  }
  setUpPage2() {
    this.modalEl.setAttribute('isdetail', true);
    this.modalEl.setAttribute('svgon', true);
    this.modalEl.animatePages();
    this.modalEl.setAttribute('backbutton', this.backLabelText);
  }
  renderModal() {
    this.document.body.appendChild(this.modalEl);
    this.isAttrAvailable('isdetail', 'true') ? this.modalEl.focusNodes() : null;
    if (!!this.modalContent || !!this.hasVideo) {
      this.modalEl.open();
      this.modalEl.addEventListener('buttonClicked', event => {
        this.buttonEventHandler(event);
        event.stopImmediatePropagation();
      }, false);
      this.modalEl.addEventListener('modalClose', () => {
        this.modalCloseHandler();
      }, false);
    }
  }
  modalCloseHandler() {
    const id = this.modalEl.dataset['buttonId'];
    if (!id) return;
    this.modalEl.removeEventListener('modalClose', this.modalCloseHandler);
    this.modalEl.removeEventListener('buttonClicked', this.buttonEventHandler);
    if (this.modalEl.parentElement === this.document.body) {
      this.document.body.removeChild(this.modalEl);
    }
    this.focusOnButton(id);
  }
  focusOnButton(id) {
    let focusEle = this.document.getElementById(id);
    if (!focusEle) return;
    focusEle = focusEle.getElementsByTagName('button')[0];
    if (focusEle && focusEle.focus) focusEle.focus();
  }
  transcludeModalBodyTemplate(button, content, contrast) {
    const videoId = get(button, 'videoId') || get(content, 'button.EmbeddedValues[0].videoId.Values[0]') || get(content, 'mediaButton.EmbeddedValues[0].videoId.Values[0]');
    const videoCaption = get(button, 'videoCaption') || get(content, 'button.EmbeddedValues[0].videoCaption.Values[0]') || get(content, 'mediaButton.EmbeddedValues[0].videoCaption.Values[0]', '');
    if (videoId) {
      return this.gdsYouTubePlayer.get(videoId, videoCaption, contrast);
    }
  }
  transcludeModalHeaderTemplate(content) {
    const heading = get(content, 'heading.Values[0]', '');
    let headerTemp = null;
    if (!!heading || get(content, 'button.EmbeddedValues[0].label.Values[0]')) {
      headerTemp = this.gdsText.getHeader(heading);
    }
    return headerTemp;
  }
  /**
   * get trip advisor reviews from reviewList
   */
  reviewsModal(locationId) {
    const reviewInfo = this.tripAdvisor.getReview(locationId);
    if (!reviewInfo) return;
    this.loadReviewModal(reviewInfo);
  }
  /**
   * trip advisor reviews modal
   */
  loadReviewModal(reviewInfo) {
    this.reviewList = get(reviewInfo, 'reviews');
    if (this.reviewList.length === 0) {
      return;
    }
    const reviews = this.reviewList.map(review => {
      const userReview = {
        description: review.text,
        username: get(review, 'user.username'),
        reviewDate: this.pageLabels['txtWroteReview'] + ' ' + moment(review.published_date).format('MMM D'),
        location: get(review, 'user.user_location.name'),
        locationIcon: 'location-pin',
        rating: review.rating_image_url,
        title: review.title,
        readMoreBtn: {
          type: 'tertiary',
          analytics: 'read more review',
          href: '#review',
          label: this.pageLabels['tripAdvisorReadMore'],
          ariaLabel: 'read more text from the available review'
        }
      };
      return userReview;
    });
    this.modalEl = this.document.createElement('gds-modal');
    this.modalEl.setAttribute('opened', true);
    const content = {
      heading: reviewInfo.name,
      overallRating: reviewInfo.rating_image_url,
      reviewLink: {
        type: 'tertiary',
        analytics: 'review-section-link',
        href: get(reviewInfo, 'web_url'),
        label: this.utilities.formatNumbers(get(reviewInfo, 'num_reviews')) + ' ' + this.pageLabels['TripAdvisorReviews'],
        ariaLabel: get(reviewInfo, 'num_reviews') + ' ' + this.pageLabels['TripAdvisorReviews']
      },
      reviews: reviews,
      allReviews: {
        type: 'primary',
        analytics: 'review-section-link',
        href: get(reviewInfo, 'web_url'),
        label: this.pageLabels['TripAdvisorSeeReviews'],
        ariaLabel: get(reviewInfo, 'num_reviews') + ' ' + this.pageLabels['TripAdvisorSeeReviews']
      },
      legalDescription: this.pageLabels['tripAdvisorLegalText'],
      readMore: this.pageLabels['tripAdvisorReadMore'],
      readLess: this.pageLabels['tripAdvisorReadLess']
    };
    this.modalContent = this.document.createElement('gds-review');
    this.modalContent.setAttribute('data', JSON.stringify(content));
    this.appendWhenAvailable(this.modalContent, '.gds-modal-body');
    this.renderModal();
  }
  getDate(dateStr, startOrEnd) {
    const today = DateTime.now();
    const eventDate = DateTime.fromFormat(dateStr, 'M/d/y');
    const isPast = eventDate < today;
    if (startOrEnd === 'end') {
      return isPast ? today.plus({
        months: 1
      }).toISO() : eventDate.toISO();
    }
    return isPast ? today.toISO() : eventDate.toISO();
  }
  getMonthsBetweenDates(startDate, endDate) {
    return Math.floor(DateTime.fromISO(endDate).diff(DateTime.fromISO(startDate), 'months').months + 1);
  }
  setCalendarData(gdsComponentContent, gdsComponent) {
    const missingDates = [];
    const startDate = get(gdsComponentContent, 'start_date[0]', '')?.split(' ')[0];
    const endDate = get(gdsComponentContent, 'end_date[0]', '')?.split(' ')[0];
    if (!startDate) missingDates.push('start_date');
    if (!endDate) missingDates.push('end_date');
    if (missingDates.length) {
      console.error(`Calendar event missing ${missingDates.join(', ')}`);
      return;
    }
    this.eventStartDate = this.getDate(startDate);
    this.eventEndDate = this.getDate(endDate, 'end');
    set(gdsComponentContent, 'start_date', this.eventStartDate);
    set(gdsComponentContent, 'end_date', this.eventEndDate);
    set(gdsComponentContent, 'timezone.zone', this.appDefaults.UPR_TIME_ZONE);
    set(gdsComponentContent, 'timezone.locale', this.locale);
    const months = this.getMonthsBetweenDates(this.eventStartDate, this.eventEndDate);
    this.getEventMonths(this.eventStartDate, this.eventEndDate, gdsComponentContent, months);
    this.addMonthSubscription(gdsComponent);
  }
  getEventMonths(startDate, endDate, item, monthCount) {
    sendEvent(CALENDAR_TRIGGER_EVENT_KEYS.GET_MONTH_EVENTS, {
      startDate,
      endDate,
      zone: this.appDefaults.UPR_TIME_ZONE,
      item,
      monthCount
    });
  }
  addMonthSubscription(gdsComponent) {
    const eventMonths = fromEvent(this.window, CALENDAR_OUTPUT_EVENT_KEYS.OUT_GET_MONTH_EVENTS).pipe(take(1)).subscribe(data => {
      if (isEmpty(data?.detail?.months)) return;
      gdsComponent.setAttribute('requested', JSON.stringify(data?.detail?.months));
    });
    this.subscriptions.add(eventMonths);
  }
  renderInputForm(inputFormComponent) {
    this.gdsInputFormService.renderInputForm(inputFormComponent);
    this.addFormToSlot(inputFormComponent);
  }
  setCalloutFormData(calloutFormComponent, backgroundColor) {
    this.gdsInputFormService.setCalloutFormData(calloutFormComponent, backgroundColor);
  }
  addFormToSlot(inputFormComponent) {
    this.document.addEventListener('gdsFormContainerLoaded', () => {
      if (this.modalEl.querySelector('upr-gds-input-form')) return;
      const gdsInputFormComponentRef = this.rootViewContainerRef.createComponent(GdsInputFormComponent);
      const gdsFormContainer = this.document.querySelector('.gds-form-container-slot');
      this.renderer2.appendChild(gdsFormContainer, gdsInputFormComponentRef.location.nativeElement);
      gdsInputFormComponentRef.instance.initForm(inputFormComponent, this.pageLabels);
    });
  }
  /**
   * * Get value from resources from Tridion and use page labels as fallback.
   * @param {any[]} resources - array of resources to search
   * @param {string} key - key to search for in resources array
   * @returns {string} the string value of the found resource.
   */
  getResourceValue(resources, key) {
    return (resources?.length ? resources?.find(resource => resource.Key === key)?.Value : this.pageLabels[key]) || '';
  }
  static {
    this.ɵfac = function GdsModalService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsModalService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject('AppDefaults'), i0.ɵɵinject(WINDOW), i0.ɵɵinject(i1.GdsYoutubeService), i0.ɵɵinject(i2.GdsTextService), i0.ɵɵinject(i3.GdsDataModelService), i0.ɵɵinject(i4.GdsCommonUtilityService), i0.ɵɵinject(i5.GdsRouteResolverService), i0.ɵɵinject(i6.GdsTripAdvisorService), i0.ɵɵinject(i7.LocaleService), i0.ɵɵinject(i8.PageLabelsResolver), i0.ɵɵinject(i9.GdsPoiService), i0.ɵɵinject(i10.GdsInputFormService), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i11.GdsComparisonTableService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsModalService,
      factory: GdsModalService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsModalService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: i1.GdsYoutubeService
  }, {
    type: i2.GdsTextService
  }, {
    type: i3.GdsDataModelService
  }, {
    type: i4.GdsCommonUtilityService
  }, {
    type: i5.GdsRouteResolverService
  }, {
    type: i6.GdsTripAdvisorService
  }, {
    type: i7.LocaleService
  }, {
    type: i8.PageLabelsResolver
  }, {
    type: i9.GdsPoiService
  }, {
    type: i10.GdsInputFormService
  }, {
    type: i0.RendererFactory2
  }, {
    type: i11.GdsComparisonTableService
  }], null);
})();

/*
 * Public API Surface of gds-modal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsModalModule, GdsModalService };
